import type { TBbox } from '@vlabs/shared/components/bbox-drawing/types';

export type BBoxesByTime = Record<string, TBbox[]>;

export const findNearestBBox = (bboxes: BBoxesByTime | null | undefined, currentTime: number): BBox[] => {
  if (!bboxes || Object.keys(bboxes).length === 0) return [];
  const threshold = 0.1;

  const times = Object.keys(bboxes).map(parseFloat);

  let left = 0;
  let right = times.length - 1;
  let nearestTime = times[0];

  while (left <= right) {
    const mid = Math.floor((left + right) / 2);
    const midTime = times[mid];

    if (midTime === currentTime) {
      nearestTime = midTime;
      break;
    }
    if (midTime < currentTime) {
      nearestTime = midTime;
      left = mid + 1;
    } else {
      right = mid - 1;
    }
  }

  if (Math.abs(currentTime - nearestTime) > threshold) {
    return [];
  }

  return bboxes[nearestTime.toFixed(2)] || [];
};
